import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
} from "antd";
import { useState } from "react";
import { Option } from "antd/es/mentions";
import { Helpers } from "../../shared/Helper";
import Repository from "../../helpers/Repository";

export const AddSyncLinkModal = ({ visible, setVisible, onAdd }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();

  const handleOk = () => {
    const data = form.getFieldsValue();
    console.log(data);
    onFinish(data);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const onFinish = (values) => {
    const key = Helpers.makeKey(19);
    message
      .loading({ content: "Adding Link, please wait!", key, duration: 0 })
      .then();
    Repository.addSyncLink(values)
      .then((res) => {
        message
          .success({ content: "Link Added successfully!", key, duration: 1 })
          .then();
        setConfirmLoading(false);
        setVisible(false);
        onAdd();
      })
      .catch((err) => {
        console.log(err);
        const response = err.response;
        if (!response) {
          message.error({ content: "Unexpected error happened", key }).then();
          return;
        }
        if (response.status !== 400) {
          message.error({ content: "Unexpected error happened", key }).then();
          return;
        }
        if (!response.data.message) {
          message.error({ content: "Unexpected error happened", key }).then();
          return;
        }

        message.error({ content: response.data.message, key }).then();
      });
  };

  return (
    <Modal
      title="Title"
      visible={visible}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Form
            layout="vertical"
            form={form}
            scrollToFirstError
            onFinish={handleOk}
          >
            <Form.Item
              label="Link"
              name="url"
              rules={[
                {
                  required: true,
                  message: "Link is required",
                  type: "url",
                },
              ]}
              hasFeedback
            >
              <Input placeholder="Link" />
            </Form.Item>
            <Form.Item
              label="Max Count"
              name="maxCount"
              rules={[
                {
                  required: true,
                  message: "Max Count is required",
                },
                {
                  type: "number",
                },
              ]}
              hasFeedback
            >
              <InputNumber
                min={1}
                max={2147483647}
                placeholder="Max Count"
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item
              label="Operation"
              name="objective"
              rules={[
                {
                  required: true,
                  message: "Operation is required",
                },
              ]}
              hasFeedback
            >
              <Select placeholder={"Select Operation Type"}>
                <Option value={"Like"}>Like</Option>
                <Option value={"Love"}>Love</Option>
                <Option value={"Haha"}>Haha</Option>
                <Option value={"Wow"}>Wow</Option>
                <Option value={"Sad"}>Sad</Option>
                <Option value={"Angry"}>Angry</Option>
                <Option value={"friendRequest"}>Friend Request</Option>
                <Option value={"followRequest"}>Follow Request</Option>
                <Option value={"pageLike"}>Page Like</Option>
                <Option value={"groupJoin"}>Group Join</Option>
                <Option value={"comment"}>Comment</Option>
                <Option value={"share"}>Share</Option>
              </Select>
            </Form.Item>
            {/*<Form.Item>*/}
            {/*    <Button type={"primary"} htmlType="submit">Add</Button>*/}
            {/*</Form.Item>*/}
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};
